import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';
@Pipe({
  name: 'timezonedDatePipe',
})
export class TimezonedDatePipe implements PipeTransform {
  transform(dateStr: string, timezone: string, format?: string): string {
    if (dateStr == null) return 'N/A';
    return moment.tz(dateStr, timezone).format(format ? format : 'MM-DD-YYYY, HH:mm');
  }
}
